module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/background-bf03bc1ac643b2c17b18b7fcadf6356f.png";